import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const TermsCondition = () => {

  return (
    <>
    <Helmet>
    <meta name="robots" content="noindex" />
    </Helmet>
      <div className="main_container">
        <section style={{ padding: "2rem 0" }}>
          <div className="container">
            <div className="the_content_single">
              <h2>Terms and Conditions</h2>
              <h4>Effective Date: May 25, 2023</h4>
              <p>
                Please read these Terms and Conditions ("Terms") carefully
                before using our website (www.konnectx.us) operated by KonnectX.
              </p>
              <h2>use of the website:</h2>
              <h3>1.1 Eligibility:</h3>
              <p>
                By accessing or using our website, you represent that you are at
                least 18 years old and have the legal capacity to enter into
                these Terms.
              </p>
              <h3>1.2 License:</h3>
              <p>
                Subject to these Terms, we grant you a limited, non-exclusive,
                non-transferable, and revocable license to access and use our
                website for personal and non-commercial purposes. You agree not
                to reproduce, distribute, modify, or create derivative works of
                the website or any content without our prior written consent.
              </p>
              <h3>1.3 User Responsibilities:</h3>
              <p>
                You agree to use the website in compliance with all applicable
                laws and regulations. If you are an Internet Provider company,
                you further agree to adhere to the following terms:
              </p>
              <h4>Compliance:</h4>
              <p>
                You shall comply with all relevant laws, regulations, and
                industry standards governing Internet service provision,
                including but not limited to data privacy, network neutrality,
                and consumer protection laws.
              </p>
              <h4>Service Quality:</h4>
              <p>
                You shall strive to provide reliable, secure, and high-quality
                Internet services to your customers, ensuring minimal downtime
                and maintaining reasonable network speeds.
              </p>
              <h4>Customer Support:</h4>
              <p>
                You shall offer adequate customer support channels to address
                customer inquiries, complaints, and technical issues promptly
                and professionally.
              </p>
              <h2>Intellectual Property:</h2>
              <h3>2.1 Ownership:</h3>
              <p>
                The website and all its contents, including but not limited to
                text, graphics, logos, images, and software, are the
                intellectual property of KonnectX or its licensors. All rights
                not expressly granted are reserved.
              </p>
              <h3>2.2 Trademarks:</h3>
              <p>
                The trademarks, service marks, and logos used and displayed on
                the website are registered or unregistered trademarks of
                KonnectX or third parties. You are not granted any right or
                license to use any of these trademarks without our prior written
                consent or the consent of the respective trademark owner.
              </p>
              <h2>Third-Party Content and Links:</h2>
              <h3>3.1 Third-Party Content:</h3>
              <p>
                Our website may contain content provided by third parties,
                including advertisements, promotions, and links to third-party
                websites. We do not endorse or assume any responsibility for the
                accuracy, reliability, or legality of such content.
              </p>
              <h3>3.2 Third-Party Links:</h3>
              <p>
                We may provide links to third-party websites for your
                convenience. We do not control or endorse the content, products,
                or services offered by these third-party websites. Your use of
                such websites is at your own risk, and we recommend reviewing
                the terms and privacy policies of those websites.
              </p>
              <h2>Limitation of Liability:</h2>
              <p>
                To the extent permitted by applicable law, in no event shall
                KonnectX or its directors, officers, employees, or agents be
                liable for any indirect, consequential, incidental, punitive, or
                special damages arising out of or in connection with your use of
                the website, even if advised of the possibility of such damages.
                Our liability to you shall not exceed the amount paid, if any,
                by you to us for accessing or using the website.
              </p>
              <h2>Indemnification:</h2>
              <p>
                You agree to indemnify, defend, and hold harmless KonnectX and
                its directors, officers, employees, and agents from and against
                any claims, liabilities, damages, losses, costs, or expenses,
                including reasonable attorneys' fees, arising out of or in
                connection with your use of the website or any violation of
                these Terms.
              </p>
              <h2>Termination:</h2>
              <p>
                We reserve the right, at our sole discretion, to terminate or
                suspend your access to the website without prior notice for any
                reason, including if we believe that you have violated these
                Terms.
              </p>
              <h2>Governing Law and Jurisdiction:</h2>
              <p>
                These Terms shall be governed by and construed in accordance
                with the laws of the United States. Any disputes arising out of
                or in connection with these Terms shall be subject to the
                exclusive jurisdiction of the courts located in the United
                States.
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default TermsCondition;
